import { RecipeVariants } from '@theme/utils/createRecipeObj';
import { createUseRecipeHook } from '@theme/utils/createUseRecipeHook';
import * as style from './Card.css';

export const useCardStyle = createUseRecipeHook(style.root);
export type CardStyleProps = RecipeVariants<typeof style.root>;
